import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/app/_app/")({
	component: RouteComponent,
	beforeLoad: async () => {
		throw redirect({ to: "/app/select-organization" });
	},
});

function RouteComponent() {
	return <div>You will be redirected.</div>;
}
